import { useEffect, useRef } from "react";
import Testimonials from "./Testimonials";
import { useDispatch } from "react-redux";
import { setActiveSection } from "../../store";

function TestimonialsSection({ preventIntersectionObserver }) {
  const ref = useRef();
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("experience"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="w-full h-max mt-24 mb-4 flex flex-col items-center"
      ref={ref}
    >
      <h1 className="text-white text-3xl w-full pl-3 mb-7">
        My Colleagues And Friends Say
      </h1>
      <div className="w-full h-max flex flex-col items-center justify-center">
        <Testimonials />
      </div>
    </div>
  );
}

export default TestimonialsSection;
